import { useEffect, useState } from 'react'
import GetFlow from '../Handlers/GetFlow'

const useGetFlow = (flow) => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            GetFlow(flow).then(data => {
                if (data.code != "0001") {
                    setData(data);
                    setIsLoading(false);
                    setError(null)
                } else {
                    setIsLoading(false);
                    setError(data.message);
                }
            }).catch(error => {
                setIsLoading(false);
                setError(error)
            });
        };
        fetchData();
    }, []);

    return [data, isLoading, error];
};

export default useGetFlow;